<template>
  <div class="chat-message-list-content">
    <div v-for="(msg, index) in messages" :key="index">
      <div v-if="msg.type === 'notification'" class="chat-message-list-notify">
        <div class="chat-message-list-notify-text">{{ notifyMsg(msg) }}</div>
      </div>
      <div v-else class="chat-message-list-item-wrap" :class="msg.from === account.im_accid ? 'chat-message-list-item-self' : 'chat-message-list-item-not-self'">
        <div class="chat-message-list-item-avatar">
          <div class="common-complex-avatar-wrapper common-complex-avatar-wrapper-nocursor">
            <div>
              <span class="m-badge m-badge-status">
                <span style="width: 36px; height: 36px; line-height: 36px; font-size: 18px; vertical-align: middle;" class="m-avatar m-avatar-image">
                  <img :src="avatar(msg.from)" alt="">
                </span>
              </span>
            </div>
          </div>
        </div>
        <div class="chat-message-list-item-content-box">
          <div class="chat-message-list-item-nick">{{ msg.fromNick ? msg.fromNick : msg.from }}</div>
          <div class="chat-message-list-item-content">
            <div class="chat-message-list-item-status" v-if="msg.from === account.im_accid && msg.type !== 'bot' && msg.scene !== 'team'">
              <div class="common-percent-wrap">
                <svg v-if="msg.readByOtherUser" style="color: #537ff4" class="common-percent-wrap-svg" width="16" height="16" viewBox="0 0 16 16">
                  <use href="#check-one"></use>
                </svg>
                <svg v-else class="common-percent-wrap-svg" width="16" height="16" viewBox="0 0 16 16">
                  <circle class="common-percent-wrap-svg-bg" r="7" cx="8" cy="8" stroke-width="1.5"></circle>
                  <circle class="common-percent-wrap-svg-content" r="4" cx="8" cy="8" fill="transparent" stroke-width="8" stroke-dasharray="calc(0 * 8 * 3.14 / 100) calc(8 * 3.14)" transform="rotate(-90 8 8)"></circle>
                </svg>
              </div>
            </div>
            <div v-if="msg.payload && msg.payload.uploadDone === false" class="chat-message-list-item-loading">
              <i class="el-icon-loading"></i>
            </div>
            <div class="chat-message-list-item-body">
              <div v-if="msg.type === 'text' || msg.type === 'bot'" class="common-parse-session-text-wrapper">{{ msg.text }}</div>
              <div v-else-if="msg.type === 'image'" class="common-parse-session-image-container">
                <div class="m-image common-parse-session-image">
                  <el-image class="m-image-img" fit="cover" :src="msg.file ? msg.file.url : msg.payload.url" :preview-src-list="[msg.file ? msg.file.url : msg.payload.url]" lazy>
                    <div slot="placeholder" class="image-slot">
                      <img style="width: 300px; height: 300px" src="/static/qyh.jpg" alt="">
                    </div>
                  </el-image>
                </div>
              </div>
              <div v-else-if="msg.type === 'file' || msg.type === 'audio'" class="common-parse-session-file-box" @click="handleLoadFile(msg)">
                <div class="common-parse-session-file-info">
                  <span>{{ msg.file ? msg.file.name : msg.payload.name }}</span>
                  <span class="file-size">{{ msg.file ? msg.file.size : msg.payload.size }}B</span>
                </div>
                <span class="m-icon common-parse-session-file-icon">
                  <svg width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class="">
                    <use xlink:href="#youkai-wenjianxuanzhong"></use>
                  </svg>
                </span>
              </div>
              <div v-else-if="msg.type === 'video'" class="common-parse-session-file-box" @click="handlePlayVideo(msg)">
                <div class="common-parse-session-file-video">
                  <video controls width="200" height="150">
                    <source :src="msg.file ? msg.file.url : msg.payload.url" type="video/mp4" />
                  </video>
                </div>
              </div>
              <div v-else-if="msg.type === 'custom'" class="common-parse-session-custom-box">
                <custom-msg :msg="msg" />
              </div>
            </div>
          </div>
          <div class="chat-message-list-item-date" :class="msg.from === account.im_accid ? 'chat-message-list-item-date-self' : ''">{{ formatTimestampToTime(msg.time) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CustomMsg from './CustomMsg'
export default {
  name: 'ChatMessageList',
  components: { CustomMsg },
  computed: {
    ...mapState({
      account: state => state.imAccount,
      imActiveAccount: state => state.imActiveAccount,
      imUserProfiles: state => state.imUserProfiles,
      messages: state => state.imMessages,
      imQyhContactData: state => state.imQyhContactData
    })
  },
  methods: {
    avatar (from) {
      if (from === this.account.im_accid) {
        return this.account.im_icon ? this.account.im_icon : 'https://yx-web-nosdn.netease.im/quickhtml/assets/yunxin/default/g2-demo-avatar-imgs/86117881728733184.jpg'
      } else {
        return this.imUserProfiles[this.imActiveAccount.to] && this.imUserProfiles[this.imActiveAccount.to].avatar ? this.imUserProfiles[this.imActiveAccount.to].avatar : 'https://yx-web-nosdn.netease.im/quickhtml/assets/yunxin/default/g2-demo-avatar-imgs/86117881728733184.jpg'
      }
    },
    formatTimestampToTime (timestamp) {
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    notifyMsg (msg) {
      console.log('this.account', this.account)
      if (msg.attach && msg.attach.type === 'addTeamMembers') {
        let ownerId = msg.attach.team.owner
        if (ownerId === this.account.im_accid) {
          let accountNameStr = msg.attach.users.filter(user => user.account !== this.account.im_accid).map(user => user.nick).join('、')
          return '你邀请' + accountNameStr + '加入群聊'
        } else {
          let owner = msg.attach.users.find(user => user.account === ownerId)
          let ownerName = owner ? owner.nick : ''
          return ownerName + '邀请你加入群聊'
        }
      } else if (msg.attach && msg.attach.type === 'updateTeam') {
        return msg.attach.team.custom ? msg.attach.team.custom : msg.fromNick + '修改了群信息'
      } else if (msg.attach && msg.attach.type === 'removeTeamMembers') {
        if (msg.attach.accounts.includes(this.account.im_accid)) {
          return '你被' + msg.fromNick + '移出群聊'
        }
        const fromName = msg.from === this.account.im_accid ? '你' : msg.fromNick
        const names = msg.attach.accounts.map(account => {
          const matched = this.imQyhContactData.find(item => item.im_accid === account)
          return matched ? matched.im_name : ''
        })
          .filter(name => name) // 去掉可能的空字符串
          .join('、')
        return fromName + '将' + names + '移出了群聊'
      } else if (msg.attach && msg.attach.type === 'leaveTeam') {
        return msg.fromNick + '退出群聊'
      }
    },
    handleLoadFile (msg) {
      let url = ''
      let name = ''
      if (msg.file) {
        let fileUrl = new URL(msg.file.url)
        name = msg.file.name
        fileUrl.searchParams.set('download', name)
        fileUrl.searchParams.delete('createTime')
        url = fileUrl.toString()
      } else {
        url = msg.payload.url
        name = msg.payload.name
      }
      let link = document.createElement('a')
      link.href = url
      link.download = name
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    handlePlayVideo (msg) {
      console.log(msg)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .chat-message-list-content {
    width: 100%;
  }
  .chat-message-list-item-wrap {
    display: flex;
    padding: 8px;
  }
  .chat-message-list-item-self {
    flex-direction: row-reverse;
  }
  .chat-message-list-item-self .chat-message-list-item-avatar {
    margin-left: 12px;
    margin-right: 0;
  }
  .common-complex-avatar-wrapper {
    width: fit-content;
    cursor: pointer;
  }
  .common-complex-avatar-wrapper-nocursor {
    cursor: default;
  }
  .m-badge {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    font-variant: tabular-nums;
    list-style: none;
    font-feature-settings: 'tnim';
    position: relative;
    display: inline-block;
  }
  .m-badge-status {
    line-height: inherit;
    vertical-align: baseline;
  }
  .m-avatar {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    list-style: none;
    font-feature-settings: 'tnum';
    position: relative;
    display: inline-block;
    overflow: hidden;
    color: #fff;
    white-space: nowrap;
    text-align: center;
    border-radius: 50%;
  }
  .m-avatar > img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .m-avatar-image {
    background: transparent;
  }
  .chat-message-list-item-wrap .chat-message-list-item-content-box {
    line-height: 1.5;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .chat-message-list-item-self .chat-message-list-item-content-box {
    align-items: flex-end;
  }
  .chat-message-list-item-wrap .chat-message-list-item-content-box .chat-message-list-item-nick {
    color: #666666;
  }
  .chat-message-list-item-wrap .chat-message-list-item-content-box .chat-message-list-item-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .chat-message-list-item-wrap .chat-message-list-item-status {
    padding-right: 8px;
  }
  .common-percent-wrap {
    display: flex;
    align-items: center;
  }
  .common-percent-wrap-svg {
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  .common-percent-wrap-svg-bg {
    fill: #ffffff;
    stroke: #537ff4;
  }
  .common-percent-wrap-svg-content {
    stroke: #537ff4;
  }
  .chat-message-list-item-wrap .chat-message-list-item-content-box .chat-message-list-item-body {
    word-break: break-all;
    word-wrap: break-word;
    white-space: break-spaces;
    line-height: 22px;
    overflow: hidden;
    max-width: 442px;
    min-width: 50px;
    border-radius: 5px;
    //border-radius: 0 12px 12px 12px;
    background: #fff;
    //background: #e8eaed;
  }
  .chat-message-list-item-self .chat-message-list-item-content-box .chat-message-list-item-body {
    background: #d6e5f6;
    border-radius: 12px 0 12px 12px;
  }
  .common-parse-session-text-wrapper {
    padding: 12px 16px;
  }
  .chat-message-list-item-not-self .chat-message-list-item-avatar {
    margin-left: 0;
    margin-right: 12px;
  }
  .chat-message-list-item-not-self .chat-message-list-item-status {
    padding-right: 0;
    padding-left: 8px;
  }
  .chat-message-list-item-not-self .chat-message-list-item-content {
    flex-direction: row-reverse;
  }
  .chat-message-list-item-wrap .chat-message-list-item-date {
    padding-top: 4px;
    font-size: 12px;
    color: #999999;
    text-align: left;
  }
  .chat-message-list-item-wrap .chat-message-list-item-date-self {
    text-align: right;
  }
  .m-image {
    position: relative;
    display: inline-block;
  }
  .m-image-img {
    width: 100%;
    height: auto;
    max-width: 300px;
    min-width: 150px;
    max-height: 300px;
    min-height: 150px;
    object-fit: cover;
    vertical-align: middle;
  }
  .common-parse-session-file-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    cursor: pointer;
  }
  .m-icon {
    display: inline-flex;
    align-items: center;
    color: inherit;
    font-style: normal;
    line-height: 0;
    text-align: center;
    text-transform: none;
    vertical-align: -0.125em;
    text-rendering: optimizelegibility;
  }
  .common-parse-session-file-box .common-parse-session-file-icon {
    font-size: 32px;
  }
  .common-parse-session-file-box .common-parse-session-file-info {
    padding-right: 16px;
    display: flex;
    flex-direction: column;
  }
  .file-size {
    font-size: 12px;
    color: #999;
    line-height: normal;
  }
  .common-parse-session-file-video {
    width: 200px;
    height: 150px;
    background-color: #1e0a18;
  }
  .video-notice {
    text-align: center;
    line-height: 150px;
    color: #fff;
  }
  .chat-message-list-notify {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
  }
  .chat-message-list-notify-text {
    color: #999;
  }
</style>



// WEBPACK FOOTER //
// src/common/im/right/chat/ChatMessageList.vue